import { PaginationType } from 'common';
import { UserType } from 'state';
import { AppRootStateType } from 'state/reducers';

export const selectUsers = (state: AppRootStateType): UserType[] => state.users.users;
export const selectCertainUser = (state: AppRootStateType): UserType =>
  state.users.certainUser;
export const selectSearch = (state: AppRootStateType): string | undefined =>
  state.users.search;
export const selectPagination = (state: AppRootStateType): PaginationType => ({
  page: state.users.page,
  count: state.users.count ?? 0,
});

export const selectUsersIsLoading = (state: AppRootStateType): boolean =>
  state.users.isLoading;
